import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { twMerge } from 'tailwind-merge';
import { CommonElementProps } from '../types';
import ElementUtils from '../utils';

export type CheckboxSize = 'small' | 'medium';

export interface CheckboxProps<T> extends CommonElementProps<T> {
  value?: T;
  onChange?: (checked: T) => void;
  size?: CheckboxSize;
}

function MuiCheckbox<T>(props: CheckboxProps<T>) {
  const {
    value,
    onChange,
    label,
    disabled,
    error,
    size = 'medium',
  } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.checked as T);
    }
  };

  const getFontSize = () => {
    switch (size) {
      case 'small':
        return 12;
      default:
        return 14;
    }
  };

  return (
    <>
      <FormControlLabel
        className={twMerge(disabled && 'cursor-not-allowed')}
        control={(
          <Checkbox
            checked={value as boolean}
            onChange={disabled ? () => { } : handleChange}
            disableRipple={disabled}
            className={twMerge(disabled && 'cursor-not-allowed')}
            size={size}
          />
        )}
        label={label as string}
        sx={{ '& .MuiFormControlLabel-label': { fontSize: getFontSize() } }}
      />
      {error && (
        <div className="absolute -bottom-5 text-error text-xs">
          {ElementUtils.renderError(error)}
        </div>
      )}
    </>
  );
}

MuiCheckbox.defaultProps = {
  value: false,
  onChange: () => { },
  size: 'medium',
};

export default MuiCheckbox;
